import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=42928089&scoped=true&"
import script from "./StudyList.vue?vue&type=script&lang=ts&"
export * from "./StudyList.vue?vue&type=script&lang=ts&"
import style0 from "./StudyList.vue?vue&type=style&index=0&id=42928089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42928089",
  null
  
)

export default component.exports